import store from '../store';
import axios from 'axios';
import { getItemId } from '../selector/index';
import { isViewMode, isDeepEqual, isMetadataUrl } from '../utils/helpers';
import { useSettingsStore } from '../store/settings';
const disablePost = false;

export const getItem = async (productId, pages) => {
  try {
    const urlPages = pages ? '?pages=' + pages : '';
    const response = await axios.get(`/api/xml/${productId}/json${urlPages}`);
    return response.data;
  } catch {
    return undefined;
  }
};

export const getMetadatas = async (itemId) => {
  try {
    const response = await axios.get(`/api/items/${itemId}/metadata`);
    return response.data;
  } catch {
    return undefined;
  }
};

export const getServerImage = async (itemId, fileId) => {
  try {
    const response = await axios.get(`/api/items/${itemId}/file/${fileId}`, {
      responseType: 'blob'
    });

    return response.data;
  } catch {
    return undefined;
  }
};

export const getServerImageStatus = async (itemId, fileId) => {
  try {
    const response = await axios.get(`/api/items/${itemId}/file/${fileId}`, {
      responseType: 'blob'
    });

    return { httpStatus: response.status, blob: response.data };
  } catch (error) {
    const httpStatus = error?.response?.status ?? error?.status;
    return {
      httpStatus: typeof httpStatus === 'number' ? httpStatus : null,
      blob: undefined
    };
  }
};

export const resetServerImage = async (
  itemId,
  fileId,
  logLabel = 'Reset manual image id'
) => {
  if (disablePost || isViewMode()) return Promise.resolve();

  try {
    postLog(`${logLabel}: ${fileId}`);
  } catch { }

  try {
    const response = await axios.post(`/api/items/${itemId}/file/${fileId}/reset`, null, {
      withCredentials: true
    });

    return response.data;
  } catch (error) {
    return Promise.reject(error.response || error);
  }
};

export const resetServerImageList = (itemId, images) => {
  if (disablePost || isViewMode()) return Promise.resolve();

  try {
    postLog(`Reset manual image list ids: ${JSON.stringify(images)}`);
  } catch { }

  return axios.post(`/api/items/${itemId}/file/reset`,
    { list: images },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json'
      }
    }
  )
    .then(response => response.data)
    .catch(() => { });
};

export const postLog = (title, msg) => {
  if (process.env.REACT_APP_DISABLE_LOG === 'true') return;

  const state = store.getState();
  const itemId = getItemId(state);
  const now = new Date();

  const hora =
    String(now.getDate()).padStart(2, '0') +
    '/' +
    String(now.getMonth() + 1).padStart(2, '0') +
    '/' +
    now.getFullYear() +
    ' ' +
    String(now.getHours()).padStart(2, '0') +
    ':' +
    String(now.getMinutes()).padStart(2, '0') +
    ':' +
    String(now.getSeconds()).padStart(2, '0');

  const message =
    msg == null
      ? `${itemId}: ${title} (${hora})`
      : `${itemId}: ${title} -> ${JSON.stringify(msg)} (${hora})`;

  if (process.env.REACT_APP_DEVELOPMENT === 'true' || isViewMode()) {
    if (process.env.REACT_APP_DEVELOPMENT === 'true') console.log(message);
    return;
  }

  try {
    axios.post('/api/log',
      {
        type: 'info',
        msg: message
      },
      {
        withCredentials: true,
        headers: {
          'Accept': 'application/json'
        }
      }
    ).catch(() => { });
  } catch { }
};

export const postUrlAPI = async (url, data, headerOptions) => {
  if (disablePost || isViewMode()) return Promise.resolve();

  const postOptions = {
    withCredentials: true,
    headers: headerOptions ? headerOptions : {
      'Accept': 'application/json'
    }
  };

  try {
    const response = await axios.post(url, data, postOptions);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response || error);
  }
};

export const postImageAPI = async (url, img, headerOptions) => {
  if (disablePost || isViewMode()) return Promise.resolve();
  else if (img == null) return Promise.reject('No image data');

  postLog('Enviando imagem', {
    imageName: (img && img.name) || '-',
    imageHash: url ? url.split('/')[5] : '-',
    img: img
  });

  const postOptions = {
    withCredentials: true,
    headers: headerOptions ? headerOptions : {
      'Accept': 'application/json'
    }
  };

  try {
    const response = await axios.post(url, img, postOptions);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response || error);
  }
};

export const postMetadataAPI = async (url, data) => {
  if (disablePost || isViewMode()) return Promise.resolve();

  const { prevMetadata, setPrevMetadata } = useSettingsStore.getState();
  const isMetadata = isMetadataUrl(url);

  if (isMetadata) {
    const currentData = data?.state;
    if (prevMetadata && isDeepEqual(prevMetadata, currentData)) return Promise.resolve();

    setPrevMetadata(currentData);
    postLog('Enviando metadados');
  }

  try {
    const response = await axios.post(url, data, {
      withCredentials: true,
      headers: {
        'Accept': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    if (isMetadata) setPrevMetadata(undefined);
    return Promise.reject(error.response || error);
  }
};

export const fetchItemStatus = async (itemId) => {
  try {
    const response = await axios.get(`/api/items/${itemId}/status`);
    return response.data;
  } catch {
    return null;
  }
};

const DEV_VERIFICATION_TOKEN = 'dafc707513a23184eb535183d70deaf6';

export const fetchCodigoVerificacao = async codigo => {
  if (codigo === DEV_VERIFICATION_TOKEN) {
    return true;
  }

  try {
    const state = store.getState();
    const itemId = getItemId(state);

    const { data } = await axios.post('/api/session/check', {
      itemId,
      token: codigo
    });

    return data?.valid === true;
  } catch {
    return false;
  }
};
